import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Button, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { VERIFY_REGISTRATION, VERIFY_NON_BEAMER_REGISTRATION } from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";

interface VerifiicationValues {
  verificationCode: string;
  verificationCodePhone: string;
}

export default () => {
  const [error, setError] = useState<string>("");
  const [resendForm] = Form.useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    registeredEmail,
    registeredPhone,
    registrationPayload,
    loginSuccessfull,
    isLoading,
  } = useSelector((state: RootState) => state.auth);

  const onSubmitHandler = (values: VerifiicationValues) => {
    let payload: VerifyCodePayload = {
      registerRequest: true,
      password: values.verificationCode,
      registrationPayload,
    };
    const email = registeredEmail;
    const phone = registeredPhone;
    if (email) {
      payload["email"] = email;
    }
    if (phone) {
      payload["phone"] = phone;
      payload["verificationCodePhone"] = values.verificationCodePhone;
    }

    const type = localStorage.getItem('TYPE');
    const connection = localStorage.getItem('CID');

    if(type  === 'nonBeamer' && connection){
      console.log('here non beamer verification')
      dispatch(VERIFY_NON_BEAMER_REGISTRATION(payload))
    }
    else{
      dispatch(VERIFY_REGISTRATION(payload));
    }
  };

  useEffect(() => {
    // issue here
    if (loginSuccessfull) {
      history.push("/dashboard");
    }
  }, [loginSuccessfull]);

  return (
    <div className="page-container auth-page">
      <Form
        className="auth-form"
        name="resend-form"
        id="resend-form"
        layout="vertical"
        form={resendForm}
        onFinish={onSubmitHandler}
        requiredMark={false}
      >
        <img
          alt="1"
          src="/images/back.png"
          className="back-btn"
          onClick={() => history.goBack()}
        />
        <h3>Verify Code</h3>
        <span>
          Please enter code you received on{" "}
          {registeredEmail && (
            <a href="" onClick={(e) => e.preventDefault()}>
              {registeredEmail}
            </a>
          )}
        </span>
        <Form.Item
          className="mt-2"
          name="verificationCode"
          rules={[{ required: true, message: "**Required Field" }]}
        >
          <Input
            type="text"
            placeholder={
              !registeredPhone ? "Verification Code" : "Email Verification Code"
            }
          />
        </Form.Item>
        {registeredPhone && (
          <>
            <span>
              Please enter code you received on{" "}
              {registeredPhone && (
                <a href="" onClick={(e) => e.preventDefault()}>
                  {registeredPhone}
                </a>
              )}
            </span>
            <Form.Item
              className="mt-2"
              name="verificationCodePhone"
              rules={[{ required: true, message: "**Required Field" }]}
            >
              <Input type="text" placeholder={"Number Verification Code"} />
            </Form.Item>
          </>
        )}
        {error && (
          <Form.Item>
            <p className="error">{error}</p>
          </Form.Item>
        )}
        <Form.Item>
          <Button
            loading={isLoading}
            type="primary"
            htmlType="submit"
            onClick={() => setError("")}
          >
            Verify
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
